import { useSwimlanePrivateApi } from './useSwimlanePrivateApi';

export const useSwimlaneEventPublisher = () => useSwimlanePrivateApi().current.publishEvent;
